module.exports = __webpack_public_path__ + "assets/images/scrolly-test/2.jpg?v=d9eab28e";